import type { TFunction } from 'i18next'
import * as Yup from 'yup'
import { isCccBusinessUnit } from '~/common/model/businessunits/predicates'
import type { Product } from '~/common/model/capabilities'

const apacPplBusinessUnits = ['apac-my', 'apac-th', 'apac-au', 'ppl-cz']
export const createAccountValidationSchema = (t: TFunction, businessUnit: string) => {
  // creates a yup schema for the account number length, based on the business unit. Defaults to 8 digits.
  const getIdSchema = (businessUnit, t) => {
    if (isCccBusinessUnit(businessUnit)) {
      return Yup.string().required(t('admin.accountNumbers.accountNumberRequired')).default('')
    }
    if (businessUnit === 'ppl-cz') {
      return Yup.string()
        .matches(/^(PPL-CZ-)?[0-9]{5,7}$/, t('admin.accountNumbers.accountNumberLength', { format: 'PPL-CZ-12345 ' }))
        .required(t('admin.accountNumbers.accountNumberRequired'))
        .default('')
    }
    if (apacPplBusinessUnits.includes(businessUnit)) {
      return Yup.string()
        .matches(/^[0-9]{10}$/, t('admin.accountNumbers.accountNumberLength', { format: '1234567890' }))
        .default('')
    }
    return Yup.string()
      .matches(/^[0-9]{8}$/, t('admin.accountNumbers.accountNumberLength', { format: '12345678' }))
      .default('')
  }

  return Yup.object({
    id: getIdSchema(businessUnit, t),
    selectedProducts: Yup.array()
      .of(Yup.object().defined())
      .test(
        'requireLocationIdForDpiReturnCCC',
        t('requireLocationIdForDpiReturnCCC'),
        // @ts-ignore
        (selectedProducts: Product[]) => {
          const isDpiReturnCCCProductSelectedWithoutLocationId = selectedProducts.some(
            (product) => product.value === 'DPI-RETURN-CCC' && !product.locationId
          )
          return !isDpiReturnCCCProductSelectedWithoutLocationId
        }
      ),
  }).defined()
}
